import { connect } from 'react-redux';

import AdministrationPageComponent from '../components/AdministrationPage';

import {
  isAdministratorSelector,
} from '../reducers/auth';


const mapStateToProps = state => {
  return {
    isAdministrator: isAdministratorSelector(state),
  };
};

const AdministrationPage = connect(mapStateToProps)(AdministrationPageComponent);

export default AdministrationPage;